import React, { useRef, useState } from 'react'
import { Input } from 'antd'

import * as CSS from './styles'
import { useTranslation } from 'react-i18next'

type Props = {
  initialValues: string
  onChange(values: string): void
}

export default function RequestTravelerNameFilter({
  initialValues = '',
  onChange
}: Props) {
  const refTimeout = useRef<NodeJS.Timeout>(null)
  const { t } = useTranslation()

  const [value, setValue] = useState<string>('')
  return (
    <CSS.Content>
      <Input
        data-test-id="request-traveler-name-filter"
        defaultValue={initialValues}
        onChange={({ target: { value = '' } }) => {
          setValue(value)
          clearTimeout(refTimeout.current)
          refTimeout.current = setTimeout(() => {
            setValue(value)
            onChange(value)
          }, 1000)
        }}
        placeholder={t('common.request-traveler-name-filter')}
        value={value}
      />
    </CSS.Content>
  )
}
